module.exports = __webpack_public_path__ + "img/nisu02.b3d1e8cd.png";